import React, {Fragment} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {QboCustomerForm} from "./QboCustomerForm";

export let CreateQboCustomer = function (props) {
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createQboCustomer,
        'QBO customer',
        props.afterSuccessfulSave
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <QboCustomerForm
                cancel={props.cancel}
                save={modelCreateEngine.createModel}
                headerText="Add QBO Customer"
                customer={props.customer}
                isNew={true}
            />
        </Fragment>
    );
};
